/* eslint-disable max-lines-per-function */
/* eslint-disable max-params */
import propTypes from 'prop-types';
import React, { useState } from 'react';
import { uuidv4 } from '../../../utils/utility';
import { ShowPasswordIcon, HidePasswordIcon } from '~svg/index';

import './input.scss';
// eslint-disable-next-line complexity
const renderInput = (
  iconUrl = '',
  id,
  name,
  disabled = false,
  rest,
  placeholder,
  value,
  type = 'text',
  error,
  inputClassName,
  tabIndex = '',
  topClass,
  bottomClass,
  language = {},
  showPassword,
  setShowPassword,
  outSideLabel,
  themeMode,
  boxColor,
  bgColorStyle,
  heightSize,
  labelColor,
  onBlur,
) => {
  return (
    <>
      <span
        id={`inputContainer${id}`}
        className={`d-flex w-100 px-3 align-items-center justify-content-start ${bgColorStyle} 
        ${heightSize === 'indropDown' ? 'py-1' : 'py-sm-2 py-1'} ${
          boxColor ? boxColor : 'bg-third-light'
        }
        ${error?.length ? ' border-danger' : ``}
        ${
          error
            ? 'error'
            : `${themeMode === 'light' ? 'lightsuccess' : 'darksuccess'}`
        }`}
        onFocus={() =>
          document
            .getElementById(`inputContainer${id}`)
            .classList.add('inputBoxShadow')
        }
        onBlur={() => {
          document
            .getElementById(`inputContainer${id}`)
            .classList.remove('inputBoxShadow');
        }}
        style={{ borderRadius: '1rem', border: '1px solid rgb(189, 198, 243)' }}
      >
        <div className="d-flex align-items-center pb-1"> {iconUrl}</div>

        <input
          autoComplete="off"
          {...rest}
          // autocomplete={`${type === 'password' ? 'new-password' : 'off'}`}
          disabled={disabled}
          tabIndex={tabIndex}
          placeholder={error ? error : placeholder}
          id={`input${id}`}
          name={name}
          value={value || ''}
          type={!showPassword ? 'text' : type}
          className={`form-control  px-2 w-100 ${
            inputClassName ? inputClassName : ''
          } ${
            outSideLabel
              ? `${`input-${themeMode}-mode  
              ${
                // for test comment this class ==> darkInputSuccess : lightInputSuccess
                value && !error
                  ? themeMode === 'dark'
                    ? 'text-white '
                    : 'text-dark'
                  : ''
              }`}`
              : `${`border-0 
            ${
              value
                ? ` ${topClass ? topClass : 'paddingTop1-85rem'} ${
                    bottomClass ? bottomClass : 'pb-1'
                  } valueInput `
                : ''
            }`}`
          } m-0   h-auto custome-input-border  
          }  
         `}
          style={{ outline: 0 }}
        />

        {type === 'password' && (
          <div
            className="svg-size d-flex align-items-center justify-content-center px-2"
            style={{
              // position: "absolute",
              // top: "50%",
              // transform: "translate(50%,-50%)",
              // left: language.direction === "rtl" ? "10px" : "",
              // right: language.direction === "ltr" ? "30px" : "",
              visibility: `${value === '' ? 'hidden' : 'visible'}`,
            }}
            onClick={() => {
              setShowPassword(!showPassword);
            }}
          >
            {showPassword ? (
              <ShowPasswordIcon size={18} color="#343a40" />
            ) : (
              <HidePasswordIcon size={18} color="#343a40" />
            )}
          </div>
        )}
      </span>
    </>
  );
};

const renderLabel = (
  id,
  values,
  value,
  error,
  label,
  labelPosition,
  themeMode,
  labelColor,
  customPlaceHolderClass,
) => {
  return (
    <label
      htmlFor={id}
      className={`text-start px-2 pt-2 ${
        value
          ? `position-validation-label`
          : labelPosition
          ? labelPosition
          : 'position-label'
      } 
          ${error ? 'text-danger' : ''}
          ${
            value && !error
              ? labelColor
                ? labelColor
                : themeMode === 'light'
                ? 'darkTextSuccess'
                : 'lightTextSuccess'
              : ''
          }
          ${customPlaceHolderClass}
          `}
    >
      <span className={`${labelColor}`}>{label}</span>
    </label>
  );
};
const renderOutSideLabel = (
  outSideLabelClass,
  outSideLabelPosition,
  language = {},
  themeMode,
  values,
  id,
  label,
  labelColor,
) => {
  return (
    <div
      className={`px-3 pb-2 ${outSideLabelClass}
    ${
      outSideLabelPosition === 'top'
        ? language.direction === 'rtl'
          ? 'align-self-start text-right'
          : ''
        : 'align-self-center'
    }
    ${
      outSideLabelPosition === 'side'
        ? language.direction === 'rtl'
          ? 'w-25 text-right'
          : 'w-25 text-left'
        : ''
    }
    
   ${
     labelColor
       ? labelColor
       : themeMode === 'light'
       ? `dark-text-color`
       : 'light-text-color'
   }
    `}
      style={{
        right: language.direction === 'rtl' ? '0' : '27px',
        left: language.direction === 'ltr' ? '0' : '27px',
      }}
    >
      {label}
    </div>
  );
};
const Input = ({
  name,
  disabled = false,
  values,
  label,
  value,
  py,
  type,
  margin,
  error,
  className,
  inputClassName,
  placeholder,
  tabIndex,
  labelPosition,
  bottomClass,
  topClass,
  language = {},
  themeMode,
  width,
  outSideLabel,
  outSideLabelClass,
  outSideLabelPosition,
  boxColor,
  heightSize,
  labelColor,
  iconUrl,
  customPlaceHolderClass,
  ...rest
}) => {
  //TODO: Please check type of every props such as outSideLabel
  //TODO: Please change rightPlaceholder to leftPlaceholder and reverse
  //TODO: Please Add defualt value for themeMode. if we dont pass this props , add wrong class such as input-undefined-mode or undefined-text-color but we expect light-text-color or input-light-mode
  const id = uuidv4();
  const [showPassword, setShowPassword] = useState(true);
  return (
    <span id="inputContainer" className="w-100">
      <label
        id={`label${id}`}
        className={`${margin} styled-input d-flex ${
          outSideLabel
            ? outSideLabelPosition === 'top'
              ? 'flex-column border-0 shadow-none'
              : 'shadow-none border-0'
            : `${`flex-row justify-content-between align-items-center 
               ${error ? 'border border-danger' : ''} 
               ${
                 value && !error
                   ? labelColor
                     ? labelColor
                     : themeMode === 'dark'
                     ? 'darkInputSuccess'
                     : 'lightInputSuccess'
                   : ''
               }
               ${value ? 'pt-mainlabel' : `${py}`}
             
               `}`
        }  w-100 
        ${className ? className : ''} 
        ${`${themeMode}-text-color`}
      
        ${
          language.direction === 'ltr' ? 'rightPlaceholder' : 'leftPlaceholder'
        } m-0 p-0
        `}
        style={{ width }}
      >
        {outSideLabel
          ? renderOutSideLabel(
              outSideLabelClass,
              outSideLabelPosition,
              language,
              themeMode,
              values,
              id,
              label,
              labelColor,
            )
          : renderLabel(
              id,
              values,
              value,
              error,
              label,
              labelPosition,
              themeMode,
              labelColor,
              customPlaceHolderClass,
            )}

        {renderInput(
          iconUrl,
          id,
          name,
          disabled,
          rest,
          placeholder,
          value,
          type,
          error,
          inputClassName,
          tabIndex,
          topClass,
          bottomClass,
          language,
          showPassword,
          setShowPassword,
          outSideLabel,
          themeMode,
          boxColor,
          heightSize,
          customPlaceHolderClass,
        )}
      </label>
    </span>
  );
};
Input.propTypes = {
  name: propTypes.string,
  disabled: propTypes.bool,
  values: propTypes.string,
  label: propTypes.string,
  value: propTypes.string,
  py: propTypes.string,
  type: propTypes.string,
  margin: propTypes.string,
  error: propTypes.string,
  className: propTypes.string,
  inputClassName: propTypes.string,
  placeholder: propTypes.string,
  tabIndex: propTypes.string,
  labelPosition: propTypes.string,
  bottomClass: propTypes.string,
  topClass: propTypes.string,
  language: propTypes.object,
  themeMode: propTypes.string,
  width: propTypes.string,
  outSideLabel: propTypes.bool,
  outSideLabelClass: propTypes.string,
  outSideLabelPosition: propTypes.string,
  boxColor: propTypes.string,
  heightSize: propTypes.string,
  labelColor: propTypes.string,
  iconUrl: propTypes.any,
  onBlur: propTypes.func,
};
Input.defaultProps = {
  name: '',
  disabled: false,
  values: '',
  label: 'Enter Your Label',
  value: '',
  py: 'py-sm-3',
  type: propTypes.oneOf[('text', 'password', 'checkbox', 'email', 'radio')],
  margin: '',
  error: '',
  className: 'label-font-responsive',
  inputClassName: '',
  placeholder: '',
  tabIndex: '',
  labelPosition: '',
  bottomClass: '',
  topClass: '',
  language: {},
  themeMode: propTypes.oneOf[('dark', 'light')],
  width: '100%',
  outSideLabel: propTypes.oneOf[(true, false)],
  outSideLabelClass: '',
  outSideLabelPosition: propTypes.oneOf[('top', 'side')],
  boxColor: '',
  labelColor: '',
  iconUrl: null,
  onBlur: () => {},
};
export default Input;
